import {
  IFeeBreakdown,
  IFeeBreakdownStage,
} from "../../../../setup/api/services/contract/models";

export type ShippingFeeBreakdownState =
  | "no-destination"
  | "not-picked-up"
  | "final";

export const getShippingFeeBreakdownState = (
  feeBreakdown?: IFeeBreakdown | null
): ShippingFeeBreakdownState | null => {
  if (feeBreakdown?.estimated == null) return null;
  if (feeBreakdown.charged == null) return "no-destination";
  if (feeBreakdown.settled == null) return "not-picked-up";
  return "final";
};

export const getFeeBreakdownAmount = (
  stage?: IFeeBreakdownStage | number | null
): number | null => {
  if (stage == null) return null;
  if (typeof stage === "number") return stage;
  return stage.amount ?? null;
};
